import { useTranslation } from 'react-i18next';
import type { Session } from '../types/models';
import { formatDateTime, formatUZS } from '../lib/format';
import { mediaUrl } from '../lib/media';
import { useUserStore } from '../store/userStore';

export default function SessionCard({ session, onClick }: { session: Session; onClick: () => void }) {
  const { t } = useTranslation();
  const lang = useUserStore((s) => s.lang);
  return (
    <button
      onClick={onClick}
      className="card text-left w-full active:opacity-90 transition flex flex-col"
    >
      <div className="relative aspect-[3/4] bg-bg-elev">
        {session.poster_url ? (
          <img
            src={mediaUrl(session.poster_url)}
            alt={session.title}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full grid place-items-center text-muted text-xs">No poster</div>
        )}
        <div className="absolute bottom-1.5 left-1.5 bg-bg/85 backdrop-blur px-2 py-0.5 rounded-full text-[10px]">
          {formatDateTime(session.starts_at, lang)}
        </div>
      </div>
      <div className="p-2.5">
        <h3 className="font-semibold text-sm leading-tight mb-1 line-clamp-2">{session.title}</h3>
        <div className="text-[11px] text-muted mb-1.5 truncate">{session.cinema_name}</div>
        <div className="text-xs">
          <span className="text-muted">{t('common.from')} </span>
          <span className="font-semibold text-accent-soft">{formatUZS(session.min_price)} {t('common.sum')}</span>
        </div>
      </div>
    </button>
  );
}
